import { render } from "./BotAlerts.vue?vue&type=template&id=532bf424"
import script from "./BotAlerts.vue?vue&type=script&lang=js"
export * from "./BotAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__